<!--
 * @Copyright: Copyright (c) 2021 Yihua, All right is reserverd
 * @name: HomePage
 * @Description: 首页
 * @FilePath: \web_manage_globalf:\work\web\app-tikfriend_web\src\pages\HomePage.vue
 * @Version: 0.1.0
 * @Autor: hselenat
 * @Date: 2021-04-27 16:16:23
 * @LastEditors: syl
 * @LastEditTime: 2022-05-27 13:45:38
 * @example: <HomePage />
-->
<template>
  <div class="home">
    <nav-bar :selectId="selectId" @handlerLi="gotoPage" />
    <section class="container-x">
      <router-view v-if="isDownloadPag == false" />
      <download
        :curData="contentData"
        :isShowWindows="isShowWindows"
        v-if="isDownloadPag == true"
        :index="0"
      ></download>
    </section>
    <footer-bar />
  </div>
</template>

<script>
import NavBar from "../components/NavBar.vue";
import FooterBar from "../components/FooterBar.vue";
import Home from "./content/Home.vue";
import Team from "./content/Team.vue";
import Download from "../pages/content/Download.vue";
import JoinUs from "./content/JoinUs.vue";
export default {
  name: "HomePage",
  components: { NavBar, FooterBar, Home, Team, Download, JoinUs },
  data() {
    return {
      curPage: this.$route.fullPath.slice(1),
      pageTitle: this.getTitle(),
      selectId: 0,
      contentData: this.$api.Index_item[0],
      isShowWindows: false,
      isDownloadPag: false,
    };
  },
  watch: {
    "$route.fullPath": function () {
      this.curPage = this.$route.fullPath.slice(1);
    },
  },
  created() {
    this.contentData = this.$api.Index_item[this.getIndex(this.curPage)-1];
    this.gotoPage({
      id: this.contentData.id,
      compName: this.curPage ? this.curPage : "/home",
      compTitle: this.getTitle(),
    });
    this.$router.push(this.$route.fullPath);
  },
  mounted() {
    // 禁用浏览器返回键
    let path = window.location.href.split("?"); //分割url
    let href = path[0] + "?" + path[1];
    if (path[1]) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.disableBrowserBack);
    }
  },
  destroyed() {
    // 清除popstate事件 否则会影响到其他页面
    window.removeEventListener("popstate", this.disableBrowserBack, false);
  },
  methods: {
    disableBrowserBack() {
      history.pushState(null, null, document.URL);
    },
    getIndex(path) {
      switch (path) {
        case "home":
          return 0;
        case "chat":
          return 1;
        case "work":
          return 2;
        case "monitor":
          return 3;
        case "joinus":
          return 4;
        default:
          return "";
      }
    },
    getTitle() {
      switch (this.curPage) {
        case "home":
          this.selectId = 0;
          return "益华集团介绍";
        // case "team":
        //   this.selectId = 1;
        //   return "互勾团队介绍";
        case "chat":
          this.selectId = 1;
          return "互勾聊天";
        case "work":
          this.selectId = 2;
          return "互勾办公";
        case "monitor":
          this.selectId = 3;
          return "互勾j监控";
        case "joinus":
          this.selectId = 4;
          return "人才招聘";

        default:
          return "益华集团介绍";
      }
    },
    gotoPage(item) {
      var that = this;
      this.$router.push("/" + item.compName);
      if (
        item.compName == "home" ||
        item.compName == "team" ||
        item.compName == "joinus"
      ) {
        that.isDownloadPag = false;
      } else if (
        item.compName == "chat" ||
        item.compName == "work" ||
        item.compName == "goudrive"||
        item.compName == "monitor"
      ) {
        that.isDownloadPag = true;
        // this.isShowWindows = item.compName == "work" ? true : false;
        this.isShowWindows = false;
        this.contentData = this.$api.Index_item.find((x) => x.id == item.id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.home {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
